export default __webpack_public_path__ + "141b4da5cbdbf4d251ef3de1d05bb011.png";